import isItemClassOfMessageType from './isItemClassOfMessageType';
import TypeOfAttachment from '../store/schema/TypeOfAttachment';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isGuid } from 'owa-guid';
import { isStringNullOrWhiteSpace } from 'owa-localize';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import ItemAttachment from 'owa-service/lib/contract/ItemAttachment';
import ItemIdAttachment from 'owa-service/lib/contract/ItemIdAttachment';

import {
    FILE_ATTACHMENT_TYPE,
    ITEM_ATTACHMENT_TYPE,
    ITEM_ID_ATTACHMENT_TYPE,
    REFERENCE_ATTACHMENT_TYPE,
    LINK_ATTACHMENT_TYPE,
} from './attachmentConstants';

export default function getTypeOfAttachment(attachment: AttachmentType): TypeOfAttachment {
    // Links dont have store ids and are retrieved from the Files folder where the Ids are Guids
    // TODO VSO: 51469 - read a property from the reference attachment to correctly identify links. The flight
    // doc-SharePoint-dogfoodUser is and always will be scoped to MSIT. Before rolling out the flight that uses
    // TypeOfAttachment.Link past MSIT we should remove this flight check and check the attachment property instead.
    // This is a temperary solution to keep OWA bug free outside of MSIT, while still enabling feature development in MSIT.
    if (
        attachment.AttachmentId &&
        isGuid(attachment.AttachmentId.Id) &&
        isFeatureEnabled('doc-SharePoint-dogfoodUser')
    ) {
        return TypeOfAttachment.Link;
    }

    switch (attachment.__type) {
        case FILE_ATTACHMENT_TYPE:
            return TypeOfAttachment.File;
        case REFERENCE_ATTACHMENT_TYPE:
            return TypeOfAttachment.Reference;
        case LINK_ATTACHMENT_TYPE:
            return TypeOfAttachment.Link;
        case ITEM_ATTACHMENT_TYPE:
            return TypeOfAttachment.Mail;
        case ITEM_ID_ATTACHMENT_TYPE:
            /**
             * This will solve a problem where we have a file being attached
             * but the assumption that the ItemId is always a Mail is misleading
             * since it can be a CalendarItem or any other Item on the Mailbox.
             * Alternatively, EmbeddedItemClass can be used to ascertain if it is a Mail Item
             * */
            const itemIdAttachment = attachment as ItemIdAttachment;
            const isMailItem = isItemClassOfMessageType(
                (<ItemAttachment>attachment).EmbeddedItemClass
            );
            if (!isMailItem && !isStringNullOrWhiteSpace(itemIdAttachment.AttachmentIdToAttach)) {
                return TypeOfAttachment.File;
            }

            return TypeOfAttachment.Mail;
        default:
            throw new Error(`Invalid type of attachment ${attachment.__type}`);
    }
}
